export default __webpack_public_path__ + "static/media/image 1.ed2005d9.png";